// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__10t_n","header":"PatientBlock_header__3Byxj","label":"PatientBlock_label__60nh6","option":"PatientBlock_option__1BorC"};